import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUploadArrow = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 14 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7 0L10.4641 4.5H3.5359L7 0Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 6,
			y: 7,
			width: 2,
			height: 9,
			rx: 1,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 17,
			width: 14,
			height: 2,
			rx: 1,
			fill: "currentColor"
		})
	]
});
export default SvgUploadArrow;
